<template>
  <div>
    <b-form-group
      :label="$t('servers.proxyService')"
      :state="validateState('server')"
    >
      <multiselect
        v-model="form.server"
        :options="proxyList"
        track-by="id"
        label="name"
        :loading="loading"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('servers.proxyService')"
        :show-no-results="false"
      />
    </b-form-group>

    <Input
      label="servers.domainName"
      id="domain"
      placeholder="examples.domain"
      v-model="form.domain"
      :state="validateState('domain')"
    />

    <Input
      label="global.destinationIp"
      id="ip"
      placeholder="examples.ip"
      v-model="form.ip"
      :state="validateState('ip')"
    />

    <Input
      label="global.destinationPort"
      id="port"
      placeholder="examples.port"
      v-model="form.port"
      :state="validateState('port')"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ProxyCreate',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      form: {
        server: '',
        domain: '',
        ip: '',
        port: '',
      },
      proxyList: [],
      loading: false,
    }
  },
  validations: {
    form: {
      server: {
        required,
      },
      domain: {
        required,
      },
      ip: {
        required,
      },
      port: {
        required,
      },
    },
  },
  created() {
    this.getProxies()
  },
  methods: {
    getProxies() {
      this.getProxyList().then((res) => {
        this.setproxyList(res)
      })
    },
    getProxyList() {
      this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get(`/packetbender/proxy/servers?position=id|desc`)
          .then(({ data }) => {
            resolve(data)
            this.loading = false
          })
          .catch((err) => {
            reject(err)
            this.loading = false
          })
      })
    },
    setproxyList(res) {
      if (res && res.data && res.data.length > 0) {
        this.proxyList = res.data
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        domain: this.form.domain,
        ip: this.form.ip,
        port: this.form.port,
        server_id: this.form.server.id,
      }

      ApiService.post(`packetbender/proxy/records`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
